class NarvarEDD extends HTMLElement {
  static observedAttributes = ['product-data', 'zip-code'];

  constructor () {
    super();
    this.isOpen = false;
    this.dropdownHeader = this.querySelector('[data-dropdown-header]');
    this.dropdownBody = this.querySelector('[data-dropdown-body]');
    this.optionTemplate = this.querySelector('[data-edd-option]');
    this.optionsContainer = this.querySelector('[data-delivery-options]');
    this.zipInput = this.querySelector('[data-zip-input]');
    this.zipSubmit = this.querySelector('[data-zip-submit]');
    this.zipCode = localStorage.getItem('eddZipCode') || window.customer?.zip || null;
    this.zipForm = this.querySelector('[data-zip-code-form]');

    this.formSubmitHandler = this.onFormSubmitHandle.bind(this);
    this.toggleHandler = this.onToggleHandle.bind(this);
    this.inputChangeHandler = this.inputChange.bind(this);
  }

  connectedCallback() {
    this.validateZipCode();
    this._getEDDData();

    this.zipForm.addEventListener('submit', this.formSubmitHandler)
    this.dropdownHeader.addEventListener('click', this.toggleHandler);
    this.zipInput.addEventListener('keyup', this.inputChangeHandler);
    this.zipInput.addEventListener('change', this.inputChangeHandler);
  }

  disconnectedCallback() {
    this.zipForm.removeEventListener('submit', this.formSubmitHandler)
    this.dropdownHeader.removeEventListener('click', this.toggleHandler);
    this.zipInput.removeEventListener('keyup', this.inputChangeHandler);
    this.zipInput.removeEventListener('change', this.inputChangeHandler);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name] = JSON.parse(newValue);
    this._getEDDData();
  }

  async _getCartData() {
    return await fetch(`${Shopify.routes.root}cart.json`)
      .then((response) => response.json())
      .then((data) => data)
      .catch((error) => {
        console.error('Narvar-edd: Could not get cart data');
        console.error('Error:', error)
      })
  }

  async _getEDDData() {
    const cartData = await this._getCartData();
    let eddSessionID = window.sessionStorage.getItem('eddSessionID');
    this.optionsContainer.classList.add('loading');
    if(!eddSessionID) {
      eddSessionID = crypto.randomUUID();
      window.sessionStorage.setItem('eddSessionID', eddSessionID);
    }

    const customerId = String(window.customer.id) || crypto.randomUUID();

    if(!this.zipCode) return;

    const eddObject = {
      destination: {
        postal_code: this.zipCode,
        country: Shopify.country
      },
      country_code: Shopify.country,
      language_code: Shopify.locale,
      display_location: 'pdp',
      order_subtotal: {
        amount: Number.parseFloat(cartData.total_price || 0),
        currency: Shopify.currency.active
      },
      customer: {
        customer_id: customerId,
      },
      items: [
        {
          sku: this["product-data"].sku,
          quantity: 1,
          original_price: {
            amount: Number.parseFloat(this["product-data"].price || 0),
            currency: Shopify.currency.active
          },
          brand: this["product-data"].brand,
        }
      ],
      session_id: eddSessionID,
      channel: 'website',
    }
    await fetch("https://edd.ecomops.workers.dev/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(eddObject),
    })
    .then(response => response.json())
    .then((data) => {
      this.updateOptions(data);
    })
    .catch(error => {
      console.error(error);
      console.error('Narvar Edd: ', error);
    });
  }

  validateZipCode() {
    const savedZipCode = localStorage.getItem('eddZipCode');
    if(this.zipCode && this.zipCode !== savedZipCode) {
      localStorage.setItem('eddZipCode', this.zipCode);
    }
  }

  onFormSubmitHandle(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.zipCode = this.zipInput.value;
    localStorage.setItem('eddZipCode', this.zipCode);
    this._getEDDData();
  }

  updateOptions(data) {
    const baseDescription = data.cart.delivery_options[0].description.match(/(?<=by )([\D\d]*)/g);
    if(baseDescription == '{{edd}}' || baseDescription == null) {
      this.querySelector('[data-delivery-description]').innerHTML = `The estimated delivery date could not be retrieved, please try again later`;
      this.querySelector('[data-delivery-zip]').setAttribute('hidden', true);
      return;
    }
    this.querySelector('[data-delivery-description]').innerHTML = `Estimated delivery by <b>${baseDescription}</b>`;
    this.querySelector('[data-delivery-zip]').removeAttribute('hidden');
    this.querySelector('[data-delivery-zip]').innerText = window.localStorage.getItem('eddZipCode');
    this.buildEddOptions(data.cart.delivery_options);
  }

  buildEddOptions(options) {
    const deliveryOptions = [];

    options.forEach((option , index) => {
      if(option.name == 'Free Standard Shipping') return;
      const optionEl = this.optionTemplate.content.cloneNode(true);
      const estimatedDate = option.description.match(/(?<=by )([\D\d]*)/gm)
      const name = option.name.indexOf("(") > -1 ? option.name.match(/^([\W\w]*)(?=\()/g) : option.name;
      const cutTime = option.name.match(/(\([\W\w)]*\))/g);
      optionEl.querySelector('[data-delivery-option-title]').innerHTML = cutTime ? `${name} <span class="edd-cut-time">${cutTime[0].replace(')', ' US and non-PO Box only)')}</span>` : name;
      optionEl.querySelector('[data-delivery-option-description]').innerHTML = `Estimated delivery by <b>${estimatedDate}</b>`;

      deliveryOptions.push(optionEl);
    })

    if(deliveryOptions.length > 0) {
      this.optionsContainer.replaceChildren(...deliveryOptions);
      this.zipInput.value = "";
      this.zipInput.dispatchEvent(new Event('change'));
      this.optionsContainer.classList.remove('loading');
    }
  }

  onToggleHandle() {
    if(this.isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.dropdownBody.removeAttribute('hidden');
    const height = this.dropdownBody.scrollHeight;
    this.dropdownBody.style.height = `${height}px`
    this.dropdownHeader.classList.add('is-open');

    this.dropdownBody.addEventListener('transitionend', () => {
      this.dropdownBody.style.height = 'auto';
      this.isOpen = true;
    }, {once: true, passive: true})
  }

  closeDropdown() {
    this.dropdownHeader.classList.remove('is-open');
    const height = this.dropdownBody.scrollHeight;
    this.dropdownBody.style.height = `${height}px`

    setTimeout(() => {
      this.dropdownBody.style.height = "0"
    }, 50);

    this.dropdownBody.addEventListener('transitionend', () => {
      this.dropdownBody.setAttribute('hidden', true);
      this.isOpen = false;
    }, {once: true, passive: true})
  }

  inputChange(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const isEmpty = this.zipInput.value.length == 0;

    if(isEmpty) {
      this.zipSubmit.setAttribute('disabled', true);
    } else {
      this.zipSubmit.removeAttribute('disabled');
    }
  }
}

if(!customElements.get('narvar-edd')) {
  customElements.define('narvar-edd', NarvarEDD);
}